"use client";

import type { PhraseState } from "@/lib/learning-journey/types";

/**
 * « Passer à la main droite » : leaving a hand's steps without doing them.
 *
 * Named by where it leads, never « Étape suivante » — from the left hand's
 * grip the next step is its own run, and a button saying « next » that
 * jumped the run too would be doing something else than it says.
 */
const LABEL: Partial<Record<PhraseState, string>> = {
  S2a: "Passer à la main droite",
  S2b: "Passer à la main droite",
  S3: "Passer aux mains ensemble",
  S4: "Passer en rythme",
};

export function skipHandLabel(target: PhraseState | null): string | null {
  return target === null ? null : (LABEL[target] ?? null);
}

export function SkipHandButton({
  target,
  onSkip,
}: {
  /** `PhraseFSMSnapshot.handSkipTarget`. Nothing is drawn for `null`. */
  readonly target: PhraseState | null;
  readonly onSkip: () => void;
}) {
  const label = skipHandLabel(target);

  if (label === null) {
    return null;
  }

  return <PassButton label={label} onClick={onSkip} />;
}

/**
 * The way on from a step, in words that say where it goes: « Passer à la main
 * droite », « Passer en rythme ». One look for every one of them.
 */
export function PassButton({
  label,
  onClick,
}: {
  readonly label: string;
  readonly onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex items-center transition-colors hover:bg-white/[0.05] hover:text-[var(--color-text-primary)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-accent)]"
      style={{
        padding: "0 12px 0 14px",
        minHeight: 36,
        borderRadius: 8,
        border: "none",
        background: "transparent",
        color: "var(--color-text-secondary)",
        fontSize: 13,
        cursor: "pointer",
      }}
    >
      {label} →
    </button>
  );
}
